import { combineReducers } from 'redux'

import { progress, setInGameAction, setPostGameAction, reset } from './progress'
import { images, setImagesAction } from './images'
import { results, addResult, clearResults } from './results'


const combinedReducer = combineReducers({
	progress,
	images,
	results
})

export default combinedReducer

export {
	setInGameAction, setPostGameAction, reset,
	setImagesAction,
	addResult, clearResults
}



// WEBPACK FOOTER //
// ./src/reducers/reducers.js